import React from 'react';
import IconSvg from '../../../../common/IconSvg';
import { TSideIcon } from '../../../services/NavIcon.types';

export const DepositIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="DepositEO" className="svgIcon" sx={styles.icon} />
);

export const SportsIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="SportsEO" className="svgIcon" sx={styles.icon} />
);

export const PromoIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="PromoEO" className="svgIcon" sx={styles.icon} />
);

export const ContactIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="ContactUsEO" className="svgIcon" sx={styles.icon} />
);

export const MyAccountIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="MyAccountEO" className="svgIcon" sx={styles.icon} />
);

export const ResponsibleGamblingIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="ResponsibleGamblingEO" className="svgIcon" sx={styles.icon} />
);
